import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DropdownHeaderModule } from './dropdown-header/dropdown-header.module';
import { DropdownItemModule } from './dropdown-item/dropdown-item.module';
import { DropdownComponent } from './dropdown.component';
import { ExperimentalDropdownItemModule } from './experimental-dropdown-item/experimental-dropdown-item.module';

@NgModule({
  imports: [CommonModule, ExperimentalDropdownItemModule, DropdownHeaderModule, DropdownItemModule],
  declarations: [DropdownComponent],
  exports: [
    DropdownComponent,
    ExperimentalDropdownItemModule,
    DropdownHeaderModule,
    DropdownItemModule,
  ],
})
export class DropdownModule {}

export { DropdownComponent } from './dropdown.component';
